export default __webpack_public_path__ + "static/media/placeholder_business03-nl-web.dc741295.png";